import { environment } from '@env/environment';
import { isNil } from 'lodash';
import { Observable, Observer } from 'rxjs';

export const MicrofrontendUtils = {
  load: (microfrontend: { path: string; element: string; parentElement: string }): Observable<void> => {
    return new Observable<void>((observer: Observer<void>) => {
      const parentElement = document.getElementById(microfrontend.parentElement);

      if (isNil(parentElement)) {
        observer.error(`${microfrontend.element} cannot find parent element: ${microfrontend.parentElement}`);
        return;
      }

      // ✅ DOM-based guard (critical fix)
      const existing = parentElement.querySelector(microfrontend.element);
      if (existing) {
        observer.next();
        observer.complete();
        return;
      }

      const script = document.createElement('script');
      script.src = microfrontend.path;

      const element: HTMLElement = document.createElement(microfrontend.element);
      element.setAttribute('state', 'init');

      parentElement.appendChild(script);
      parentElement.appendChild(element);

      script.onload = () => {
        observer.next();
        observer.complete();
      };

      script.onerror = () => {
        observer.error(`error loading ${microfrontend.path}`);
      };
    });
  },
  unload: (microfrontend: { path: string; element: string; parentElement: string }) => {
    const parentElement = document.getElementById(microfrontend.parentElement);
    if (isNil(parentElement)) {
      return;
    }
    const element = document.getElementById(microfrontend.element);
    if (isNil(element)) {
      return;
    }
    parentElement.removeChild(element);
    const script = document.querySelector(`script[src="${microfrontend.path}"]`);
    if (script) {
      parentElement.removeChild(script);
    }
  },
  loadMfeScript: (url: string): Observable<void> => {
    return new Observable<void>((observer: Observer<void>) => {
      const script = document.createElement('script');
      script.src = url;
      script.onload = () => {
        observer.next();
        observer.complete();
      };
      script.onerror = (error: any) => {
        observer.error(`error loading ${url}`);
      };
      document.head.appendChild(script);
    });
  },
  unloadMfeScript: (url: string): void => {
    const script = document.querySelector(`script[src="${url}"]`);
    if (script) {
      document.head.removeChild(script);
    }
  },
  getUrl: (originUrl: URL): string => {
    if (originUrl.hostname.toLowerCase().includes('localhost')) {
      return originUrl.href;
    } else {
      return `/${environment.proxyMfeUrl}/${originUrl.hostname}${originUrl.pathname}`;
    }
  },
};
